export enum SyberryTodayApiCheckinStatus {
  NOT_REQUIRED = 'NOT_REQUIRED',
  REQUIRED = 'REQUIRED',
  CONFIRMED = 'CONFIRMED',
  SKIPPED = 'SKIPPED',
  POSTPONED = 'POSTPONED',
}

export enum SyberryTodayApiAllocationStatus {
  ON_TRACK = 'ON_TRACK',
  BEHIND = 'BEHIND',
  AHEAD = 'AHEAD',
  COMPLETED = 'COMPLETED',
}

export enum SyberryTodayApiPersonalBacklogCategory {
  INBOX = 'inbox',
  BLOCKED = 'blocked',
  TODAY = 'today',
  ALL = 'all',
  ONGOING_ACTIVITY = 'ongoing_activity',
  PARENT_TASKS = 'parent_tasks',
}

export enum SyberryTodayApiBacklogSectionKey {
  TODAY = 'today',
  LATER = 'later',
  ONGOING_ACTIVITY = 'ongoingActivity',
  PARENT_TASKS = 'parentTasks',
}

type SyberryTodayApiUser = {
  id: number;
  name: string;
};

type SyberryTodayApiIssueStatus = {
  id: number;
  name: string;
};

export type SyberryTodayApiIssue = {
  id: number;
  subject: string;
  author: Nullable<SyberryTodayApiUser>;
  assignee: Nullable<SyberryTodayApiUser>;
  status: SyberryTodayApiIssueStatus;
  dueDate: Nullable<string>;
  personalBacklogCategory: SyberryTodayApiPersonalBacklogCategory;
  personalBacklogPosition: Nullable<number>;
  customQueuePosition: Nullable<number>;
  redmineUrl: string;
};

export type SyberryTodayApiQueue = {
  id: number;
  name: string;
  isSkillQueue: boolean;
  issues: SyberryTodayApiIssue[];
};

export type SyberryTodayApiBacklogSection = {
  queues: SyberryTodayApiQueue[];
  issues: SyberryTodayApiIssue[];
};

export type SyberryTodayApiProject = {
  id: number;
  name: string;
  today: SyberryTodayApiBacklogSection;
  later: SyberryTodayApiBacklogSection;
  ongoingActivity: SyberryTodayApiBacklogSection;
  parentTasks: SyberryTodayApiBacklogSection;
};

export type SyberryTodayApiCheckinStatusResponse = {
  id: string;
  date: string;
  status: SyberryTodayApiCheckinStatus;
  lastConfirmedAt: Nullable<string>;
  lastSkippedAt: Nullable<string>;
  lastPostponedAt: Nullable<string>;
  postponeInEffectUntil: Nullable<string>;
  deadline: Nullable<string>;
};

export type SyberryTodayApiResponse = {
  id: string;
  checkin: SyberryTodayApiCheckinStatusResponse;
  projects: SyberryTodayApiProject[];
  systemWarning: Nullable<string>;
};

export type SyberryTodayApiUpdateIssueCategoryRequest = {
  personalBacklogCategory: SyberryTodayApiPersonalBacklogCategory;
};

export type SyberryTodayApiOrderPosition = {
  position: number;
  oldPosition?: number;
};

export type SyberryTodayApiUpdateIssueOrderRequest = {
  positions: Record<string, SyberryTodayApiOrderPosition>;
};

export type SyberryTodayApiCreateTimeEntryRequest = {
  timeSpent: string;
  activityId: number;
  spentOn?: string;
  comments?: string;
};

export type SyberryTodayApiConfirmCheckinRequest = {
  dailyCheckin: {
    reviewedInbox: true;
    plannedToday: true;
  };
  allocations?: Record<string, number>;
};

type SyberryTodayApiProjectAllocation = {
  projectId: string;
  projectLegacyId: number;
  projectName: string;
  minimumPlannedHours: number;
  maximumPlannedHours: number;
  targetPlannedHours: number;
  spentHours: number;
  remainingMinimumHours: number;
  remainingMaximumHours: number;
  progressPercent: number;
  recommendedTodayHours: number;
  status: SyberryTodayApiAllocationStatus;
};

export type SyberryTodayApiCurrentWeekAllocationResponse = {
  employeeAlias: string;
  totalMinimumPlannedHours: number;
  totalMaximumPlannedHours: number;
  totalTargetPlannedHours: number;
  totalSpentHours: number;
  totalRemainingMinimumHours: number;
  totalRemainingMaximumHours: number;
  totalRecommendedTodayHours: number;
  totalProgressPercent: number;
  globalStatus: SyberryTodayApiAllocationStatus;
  projects: SyberryTodayApiProjectAllocation[];
};
